import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectActivatedFireId } from "features/map/control/selectors"
import { selectSatelliteFlightById } from "features/entity-caching/flights/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { CogOrthoLayer } from "plugins/Orthomosaic/layers/CogOrthoLayer"
import { selectOrthoComparison, directionToClip } from "plugins/Orthomosaic/OrthoComparisonSlice"
import { cogOrthoBbox, hueTransformForSensor, selectActiveCogOrtho } from "./satelliteLayer"

export function useSatelliteComparisonBoostLayer() {
    const comparison = useAppSelector(selectOrthoComparison)
    const fireId = useAppSelector(selectActivatedFireId)
    const workspaceId = useAppSelector(selectActiveWorkspaceId())
    const satelliteFlight = useAppSelector(selectSatelliteFlightById(comparison.flightId ?? ""))

    const { flightId, direction, threshold, comparisonOpacity } = comparison
    if (!flightId || threshold === null) return []
    if (!satelliteFlight) return []
    const cogOrtho = selectActiveCogOrtho(satelliteFlight)
    if (!cogOrtho) return []

    return [
        CogOrthoLayer({
            id: `Satellite-boost:${flightId}:${cogOrtho.fileId}`,
            orgId: workspaceId || "",
            projectId: fireId || "",
            flightId: satelliteFlight.demoId || flightId,
            source: "satellite",
            cogId: cogOrtho.fileId,
            isDemo: !!satelliteFlight.demoId,
            bbox: cogOrthoBbox(cogOrtho),
            maxZoom: cogOrtho.maxZoom || 21,
            minZoom: cogOrtho.minZoom || 8,
            opacity: comparisonOpacity / 100,
            comparisonClip: directionToClip(direction, threshold),
            transform: hueTransformForSensor(satelliteFlight.sensorType),
        }),
    ]
}
